export default "__VITE_ASSET__C$GK6Ypq__"